export default __webpack_public_path__ + "static/media/people5.6269fee4.jpeg";